var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7099 1.5L0.149902 13L3.5799 19L10.1299 7.5M8.7299 13L5.2999 19H18.4199L21.8499 13M21.2799 12L14.4199 0H7.5799H7.5699L14.4299 12H21.2799Z",
    fill: "black",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/googleDrive.198ca66980c71d542060c5f7a10e4f11.svg";
export { ForwardRef as ReactComponent };